import { render, staticRenderFns } from "./teaserCollectionBlock.vue?vue&type=template&id=d475c796&"
import script from "./teaserCollectionBlock.vue?vue&type=script&lang=js&"
export * from "./teaserCollectionBlock.vue?vue&type=script&lang=js&"
import style0 from "./teaserCollectionBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports